import { useNotify, useRecordContext } from 'react-admin';
import FetchButton, { FetchButtonProps } from './FetchButton';

interface AuthPasswordRegenButtonProps extends Omit<FetchButtonProps, "urlSlug" | "options"> {
}

const AuthPasswordRegenButton = (props: AuthPasswordRegenButtonProps) => {
  const notify = useNotify();
  const record = useRecordContext();

  if (!record || !record.id) {
    return <h3>Please save before generating Password</h3>;
  }

  return (
    <FetchButton
      label="Gen Password"
      urlSlug="auth-password-regen"
      options={{ method: 'PUT' }}
      onSuccess={(res) => {
        if (Array.isArray(res.json)) {
          // setShowDrawer(true);
        } else {
          notify('myroot.notify.auth.passwordRegen', { type: "info", autoHideDuration: 15000, messageArgs: { 'newPassword': res.json.password } });
        }
        console.log(res.json);
      }}
      {...props}
    />
  )
}

export default AuthPasswordRegenButton;
